module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAATCAYAAABobNZCAAAA7UlEQVRIiWN88fr9f4YBAOIiAgxMA2ExDMAtP3vuIkNASDyYphdgBAU7yMKG5h6Gj58+MfDz8TE01JYwGBvpgxUEhSUyvHn7DqtmEWEhhnWr5pNlMSjYwZZHx2cxlBRmMuQX1zBM6mtl6OqdwrB04XQGRkZGsn1FtOUwATtnf4ZDezfSzEJ0ywc0wbEQUkCrOCfKcnIM75q8HEOsLDcSQ4wmwY5uETaLaWY5soW4LAYBmsY5PouJspySBEUIDHzZHhWXwXDh4hWwwLnzlxhAJR49wMCX7SAOyAFNrX0MddVFcItpCTDKdnqCAS/bAUGMcik67cs5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdhjtb1-2.png
// module id = 863
// module chunks = 0